import React from 'react';
import {Stack} from '@mui/material';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';

import {StyledSpecialtiesGrid, StyledTypography} from './styles';

import {MostSearchedListProps} from './types';
import {MostSearchedCard} from './components/MostSearchedCard';
import {useMostSearchedList} from './hooks/useMostSearchedList';

const {mostSearched} = translations['pt-br'].privateFlow.bookingFlow.specialtyFlow;

export function MostSearchedList({
	flowType,
	mostSearchedArr,
	handleSelectCard,
}: MostSearchedListProps) {
	const {filteredMostSearched} = useMostSearchedList({
		flowType,
		mostSearchedArr,
	});

	if (filteredMostSearched?.length === 0) {
		return null;
	}

	return (
		<Stack mt={2} gap={2}>
			<StyledTypography variant="subheader">{mostSearched}</StyledTypography>
			<StyledSpecialtiesGrid>
				{filteredMostSearched?.map((specialty, index) => (
					<MostSearchedCard
						key={index}
						dataTagId={AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_MAIS_PROCURADA}
						text={formatText(specialty?.formattedText)}
						handleClick={() => handleSelectCard(specialty)}
						selected={false}
						specialtyCode={specialty.code}
						showSpecialtyDetailsButton={specialty.hasDefinition}
					/>
				))}
			</StyledSpecialtiesGrid>
		</Stack>
	);
}
